module.exports = __webpack_public_path__ + "static/media/recognitionImg.eac89d9f.svg";